export const UPDATE_PROFILE = 'UPDATE_PROFILE'
export const UPDATE_PROFILE_RES = 'UPDATE_PROFILE_RES'